//引入axios 
import request from '../utils/request'// 这里是引入咱们的axios用axios来进行异步接口请求
//修改信息
export function setUserInfo(data){
    return request({
        url:'/api/tenim/portrait_set',
        method:'post',
        data, 
    })
}
//获取oss信息
export function getOsstoken(data){
    return request({
        url:'/api/common/getOssToken',
        method:'post',
        data, 
    })
}
//公告
export function getGonggao(data){
    return request({
        url:'/api/index/gonggao',
        method:'post',
        data, 
    })
}
//供应商列表
export function getSupplierList(data){
    return request({
        url:'/api/supplier/list',
        method:'post',
        data, 
    })
}
//供应商详情
export function getSupplierDetail(data){
    return request({
        url:'/api/supplier/detail',
        method:'post',
        data, 
    })
}

//订单列表
export function getUserOrderList(data){
    return request({
        url:'/api/order/userOrderList',
        method:'post',
        data, 
    })
}
//分类接口
export function getCate(data){
    return request({
        url:'/api/index/cate',
        method:'post',
        data, 
    })
}
//批量发送消息
export function batchSendMsg(data){
    return request({
        url:'/api/ztim/batchSendMsg',
        method:'post',
        data, 
    })
}
//用户订单数量
export function userOrderNum(data){
    return request({
        url:'/api/order/userOrderNum',
        method:'post',
        data, 
    })
}
//用户取消订单
export function userCancelOrder(data){
    return request({
        url:'/api/order/userCancelOrder',
        method:'post',
        data, 
    })
}
//用户删除订单
export function userDelOrder(data){
    return request({
        url:'/api/order/userDelOrder',
        method:'post',
        data, 
    })
}
//用户申请退款
export function userApplyRefund(data){
    return request({
        url:'/api/order/applyRefund',
        method:'post',
        data, 
    })
}
//退款订单列表
export function userRefundList(data){
    return request({
        url:'/api/order/refundList',
        method:'post',
        data, 
    })
}
//退款订单数量
export function userRefundOrderNum(data){
    return request({
        url:'/api/order/userRefundOrderNum',
        method:'post',
        data, 
    })
}
//赊销退款
export function cancelRefund(data){
    return request({
        url:'/api/order/cancelRefund',
        method:'post',
        data, 
    })
}
//确认收货
export function receiveOrder(data){
    return request({
        url:'/api/order/receiveOrder',
        method:'post',
        data, 
    })
}
//系统消息
export function getnotReadNum(data){
    return request({
        url:'/api/notice/notReadNum',
        method:'post',
        data, 
    })
}
//系统消息列表
export function getNoticelist(data){
    return request({
        url:'/api/notice/list',
        method:'post',
        data, 
    })
}
//轮播图
export function getBanner(data){
    return request({
        url:'/api/index/banner',
        method:'post',
        data, 
    })
}


//加好友
export function jhaoyou(data){
    return request({
        url:'/api/ztim/collect',
        method:'post',
        data, 
    })
}
//加好友
export function shaoyou(data){
    return request({
        url:'/api/ztim/cancelCollect',
        method:'post',
        data, 
    })
}

//客户信息
export function getUserDesc(data){
    return request({
        url:'/api/index/getUserdesc',
        method:'post',
        data, 
    })
}
